const SearchOrdersStyle = (theme) => ({
  wrapper: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    backgroundColor: " #FAFAFA",
  },
  scheduledVisitsHeader: {
    display: "flex",
    flexDirection: "column",
    borderBottom: "1px solid #979797",
    backgroundColor: "white",
    fontSize: 34,
    fontWeight: "Bold",
    fontFamily: "Proxima Nova",
  },
  scheduledVisitsBody: {
    "overflow-y": "auto",
    display: "flex",
    padding: "23px 150px",
  },
  item: {},

  errorWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  formContainer: {
    display: "flex",
    flexDirection: "column",
    maxWidth: 980,
    flex: 1,
    alignSelf: "center",
  },
  formTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 28,
  },

  firstRow: {
    marginTop: 25,
  },
  formRow: {
    display: "flex",
    marginBottom: 30,
  },

  textInput: {
    color: "#242424",
    fontFamily: "Proxima Nova",
    fontSize: "14px",
    letterSpacing: 0,
    padding: "0px 10px",
    backgroundColor: "white",
    lineHeight: "17px",
    width: 331,
    height: 41,
    border: "1px solid #979797",
    boxSizing: "border-box",
    outline: "none",
  },
  dateTextInput: {
    width: "159px !important",
  },
  throughStyle: {
    margin: "auto",
    top: 10,
    marginLeft: 17,
    marginRight: 17,
  },
  placeholder: {
    visibility: "hidden",
  },

  inputWrapper: {
    display: "flex",
    flexDirection: "column",
    "& > div > div": {
      display: "flex",
    },
  },

  titleText: {
    color: "#242424",
    fontFamily: "Proxima Nova",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: 0,
    lineHeight: "17px",
  },
  orderNumber: {
    marginRight: 235,
  },

  dateInputWrapper: {
    display: "flex",
  },
  medButton: {
    boxShadow: "none",
    marginBottom: 40,
    height: 40,
    width: 160,
    textTransform: "none",
    fontSize: 16,
    lineHeight: "18px",
    padding: "0px 10px",
    fontWeight: "bold",
    backgroundColor: "#1c4445",
    fontFamily: "Proxima Nova",
    "&:hover": {
      backgroundColor: "#1c4445",
      boxShadow: "none",
    },
    "&:active": {
      backgroundColor: "#1c4445",
      boxShadow: "none",
    },
    "&:focus": {
      backgroundColor: "#1c4445",
      boxShadow: "none",
    },
    "&:disabled": {
      color: "white",
      boxShadow: "none",
    },
  },
});

export default SearchOrdersStyle;
